import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { displayDateFormatOptions } from 'utils/date';

interface ResearchItemProps {
  title: string;
  author?: string;
  date: string;
  link: string;
  countOfReading?: number;
  className?: string;
}

export const ResearchItem: FC<ResearchItemProps> = ({ title, author, date, link, countOfReading }) => {
  const { formatDate } = useIntl();

  const onOpen = useCallback(() => {
    window.open(link, '_blank');
  }, [link]);

  return (
    <div className="d-flex h-100">
      <div className="pe-3 flex-shrink-0 flex-grow-0">
        <em className="icon icon-md">article</em>
      </div>
      <div className="flex-grow-1 flex-shrink-1 d-flex flex-column">
        <div className="flex-grow-1 pt-1">
          <a className="text-primary mt-1" onClick={onOpen}>
            <h5>{title}</h5>
          </a>
        </div>
        <div className="text-secondary d-flex justify-content-between align-items-end">
          <div>
            {author && (
              <>
                <u>{author}</u>
                <span className="px-1">-</span>
              </>
            )}
            <span>{formatDate(date, displayDateFormatOptions)}</span>
          </div>
          <div className="align-self-end">
            {countOfReading !== undefined && (
              <span className="mx-1">
                <i className="icon icon-sm me-1">visibility</i>
                {countOfReading}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ResearchItem.displayName = 'ResearchItem';
